import { useState, useCallback } from 'react'
import OsobaService from '@/services/OsobaService'

export default function useOsobaData() {
	const [data, setData] = useState([])
	const [loading, setLoading] = useState(true)
	const [loadingMore, setLoadingMore] = useState(false)
	const [error, setError] = useState(null)
	const [totalCount, setTotalCount] = useState(0)
	const [hasMore, setHasMore] = useState(false)
	const [filters, setFilters] = useState({})
	const [sortColumn, setSortColumn] = useState('_id')
	const [sortDirection, setSortDirection] = useState('desc')
	const [limit, setLimit] = useState(50)

	const loadData = useCallback(async () => {
		setLoadingMore(prevLoadingMore => {
			if (!prevLoadingMore) setLoading(true)
			return prevLoadingMore
		})
		setError(null)

		const searchText = (filters.searchText || '').trim()
		const requestOptions = {
			limit,
			sortColumn,
			sortDirection,
		}
		const result = searchText
			? await OsobaService.search(searchText, requestOptions)
			: await OsobaService.getAll(requestOptions)

		if (result.error) {
			setError(result.error)
			setData([])
			setTotalCount(0)
			setHasMore(false)
		} else {
			let rows = Array.isArray(result.data) ? result.data : []
			if (filters.id_placowka) {
				rows = rows.filter(item => {
					const placowkaValue = item?.id_placowka
					const placowkaId =
						typeof placowkaValue === 'object'
							? placowkaValue?._id || placowkaValue?.id || null
							: placowkaValue || null
					return String(placowkaId) === String(filters.id_placowka)
				})
			}
			setData(rows)
			setTotalCount(rows.length)
			setHasMore(false)
		}

		setLoading(false)
		setLoadingMore(false)
	}, [limit, sortColumn, sortDirection, filters])

	const handleLoadMore = useCallback(() => {
		if (hasMore && !loadingMore) {
			setLimit(prev => prev + 50)
			setLoadingMore(true)
		}
	}, [hasMore, loadingMore])

	const setSorting = useCallback((column, direction) => {
		setSortColumn(column)
		setSortDirection(direction)
	}, [])

	const updateFilters = useCallback(newFilters => {
		setFilters(prevFilters => ({ ...prevFilters, ...newFilters }))
	}, [])

	const clearError = useCallback(() => {
		setError(null)
	}, [])

	return {
		data,
		loading,
		loadingMore,
		error,
		totalCount,
		hasMore,
		loadData,
		handleLoadMore,
		setSorting,
		updateFilters,
		sortColumn,
		sortDirection,
		searchQuery: filters.searchText || '',
		clearError,
	}
}
